// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"64234ac3","310":"f6f49b1f","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};